import sharedMutations from "@/store/utils/shared-mutations";

const AFTER_DELETE_ACTIONS = (state, id) => {
  const highlight = state.clubTeamHighlights.find(highlight => highlight["id"] === id);
  state.clubTeamHighlights.splice(state.clubTeamHighlights.indexOf(highlight), 1);
}
export default {
  ...sharedMutations,
  AFTER_DELETE_ACTIONS,
};
